const whiteTheme = {
    'common.bi.image': '/static/logo.png',
    'common.bisize.width': '40px',
    'common.bisize.height': '43px',
    'common.backgroundImage': '',
    'common.backgroundColor': '#fff',
    'common.border': '',
  
    // header
    'header.backgroundImage': 'none',
    'header.backgroundColor': 'transparent',
    'header.border': '0px',
  
    // load button
    'loadButton.backgroundColor': '#fff',
    'loadButton.border': '1px solid #ddd',
    'loadButton.color': '#222',
    'loadButton.fontFamily': '\'Noto Sans\', sans-serif',
    'loadButton.fontSize': '12px',
  
    // download button
    'downloadButton.backgroundColor': '#d7311c',
    'downloadButton.border': '1px solid #d7311c',
    'downloadButton.color': '#fff',
    'downloadButton.fontFamily': '\'Noto Sans\', sans-serif',
    'downloadButton.fontSize': '12px',
  
    // main icons
    'menu.normalIcon.path': '/icon-d.svg',
    'menu.normalIcon.name': 'icon-d',
    'menu.activeIcon.path': '/icon-b.svg',
    'menu.activeIcon.name': 'icon-b',
    'menu.disabledIcon.path': '/icon-a.svg',
    'menu.disabledIcon.name': 'icon-a',
    'menu.hoverIcon.path': '/icon-c.svg',
    'menu.hoverIcon.name': 'icon-c',
    'menu.iconSize.width': '24px',
    'menu.iconSize.height': '24px',
  
    // submenu primary color
    'submenu.backgroundColor': '#fefefe',
    'submenu.partition.color': '#000',
  
    // submenu icons
    'submenu.normalIcon.path': '/icon-d.svg',
    'submenu.normalIcon.name': 'icon-d',
    'submenu.activeIcon.path': '/icon-b.svg',
    'submenu.activeIcon.name': 'icon-b',
    'submenu.iconSize.width': '32px',
    'submenu.iconSize.height': '32px',
  
    // submenu labels
    'submenu.normalLabel.color': '#d7311c',
    'submenu.normalLabel.fontWeight': '500',
    'submenu.activeLabel.color': '#d7311c',
    'submenu.activeLabel.fontWeight': '500',
  
    // checkbox style
    'checkbox.border': '1px solid #ccc',
    'checkbox.backgroundColor': '#fff',
  
    // rango style
    'range.pointer.color': '#333',
    'range.bar.color': '#ccc',
    'range.subbar.color': '#606060',
  
    'range.disabledPointer.color': '#d3d3d3',
    'range.disabledBar.color': 'rgba(85,85,85,0.06)',
    'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',
  
    'range.value.color': '#000',
    'range.value.fontWeight': 'normal',
    'range.value.fontSize': '14px',
    'range.value.border': '0',
    'range.value.backgroundColor': '#f5f5f5',
    'range.title.color': '#000',
    'range.title.fontWeight': 'lighter',
  
    // colorpicker style
    'colorpicker.button.border': '0px',
    'colorpicker.title.color': '#000'
  }
  
  export default whiteTheme
  